import httpClient from '../httpClient';

const login = async (data) => {
  return await httpClient.post(`${process.env.REACT_APP_API_HOST}/token/auth/`, data);
};

export {
  login
};
